import { useSelector } from 'react-redux';

export const useTasksCount = () => {
  const totalTasks = useSelector((state) => state.alerts.totalAlerts);

  return totalTasks;
};
